import { LA28_PRODUCTION_HOSTNAME, LA28_STAGING_HOSTNAME, LA28_TRMS_HOSTNAME } from "./instance-constants";
import { Instance } from "./instance-types";

const SENTRY_DSN = {
    [Instance.App]: "https://714bc62603359a8e3ec14212ac77db77@o4507453584637952.ingest.de.sentry.io/4507453594533968",
    [Instance.La28]: "https://a1011c7b91d983781be79fab0110a689@o4512123644936192.ingest.us.sentry.io/4512123652538368",
};

const REPLAY_SESSION_SAMPLE_RATE = {
    [Instance.App]: 0.15,
    [Instance.La28]: 1.0,
};

export function getInstance(hostname: string) {
    switch (true) {
        case hostname.endsWith(LA28_TRMS_HOSTNAME):
        case hostname.endsWith(LA28_PRODUCTION_HOSTNAME):
        case hostname.endsWith(LA28_STAGING_HOSTNAME):
            return Instance.La28;
        default:
            return Instance.App;
    }
}

export function getSentryDsn(instance: Instance) {
    return SENTRY_DSN[instance];
}

export function getReplaySessionSampleRate(instance: Instance) {
    return REPLAY_SESSION_SAMPLE_RATE[instance];
}
